import { Injectable } from '@angular/core';
import { toast } from 'ngx-sonner';
import { ToastComponent } from '../components/global/toast/toast.component';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor() { }

  public show(type: string, message: string, header:string) {
    const componentProps: Record<string, any> = {
      type,
      message,
      header
    };

    toast.custom(ToastComponent, {
      componentProps,
      duration: 4000,
      position: 'bottom-center',
    });
  }

}
